module.exports = __webpack_public_path__ + "img/skills-nova-sor-2.66ccf6a2.png";